import {
  Card,
  CardMedia,
  Typography,
  Box,
  makeStyles,
  Button,
} from "@material-ui/core";
import { useTranslate } from "react-admin";

const useStyles = makeStyles({
  allContainer: {
    width: 160,
    height: 160,
    padding: 0,
    borderRadius: 12,
    zIndex: 0,
    margin: "9px 0",
  },
  imageContainer: {
    width: 162,
    height: 92,
    margin: "0 auto",
    position: "relative",
  },
  image: { width: 162, height: 90, margin: "0 auto" },
  viewButton: {
    width: 48,
    height: 22,
    position: "absolute",
    top: 10,
    right: 10,
    borderRadius: 12,
    backgroundColor: "#1b1b1b60",
    color: "white",
  },
  productName: {
    fontSize: 18,
    color: "#828282",
    marginTop: 4,
    marginLeft: 12,
    fontWeight: 550,
  },
  productId: {
    fontSize: 9,
    color: "#828282",
    marginTop: 0,
    marginLeft: 12,
    lineHeight: "1.0em",
  },
  priceContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 10,
    marginRight: 8,
    justifyContent: "flex-end",
    alignItems: "baseline",
  },
  productPrice: {
    fontSize: 16,
    color: "#828282",
    marginLeft: 5,
    fontWeight: 550,
  },
  thb: {
    fontSize: 10,
  },
});

const ProductButton = ({ url, name, price, id, onClick, onClickView }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Card className={classes.allContainer} onClick={onClick}>
      <Box className={classes.imageContainer}>
        <CardMedia className={classes.image} image={url} title={name} />
        <Button
          className={classes.viewButton}
          onClick={(e) => {
            e.stopPropagation();
            onClickView();
          }}
        >
          {translate("ra.text.view")}
        </Button>
      </Box>
      <Typography
        className={classes.productName}
        align="left"
        fontWeight="fontWeightBold"
        display="initial"
        noWrap
      >
        {name}
      </Typography>
      <Typography className={classes.productId} align="left" noWrap>
        {process.env.REACT_APP_CUSTOM_HIDE_PRODUCT_CODE === "yes" ? "" : id}
      </Typography>
      <Box className={classes.priceContainer}>
        <Typography className={classes.thb} align="right">
          THB
        </Typography>
        <Typography className={classes.productPrice} align="right">
          {Number(price).toLocaleString()}
        </Typography>
      </Box>
    </Card>
  );
};
//style={{ width: 132, height: 93 }}
export default ProductButton;
